import { gql, useQuery } from "@apollo/client";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

const Q_NotificationCount = gql`
  query notificationCounter($businessId: BigInt) {
    notificationCount(businessId: $businessId)
  }
`;

function useGetNotificationCount(busId, permission,skip) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_NotificationCount,
    requestConfig({ module: "AVC_NOTIFICATION", variables: { ...(busId && {  businessId: parseInt(busId)}) }, Microservice: permission,skip:skip })
  );
  return { loading, error, data, refetch };
}
export default useGetNotificationCount;
